import { reactive, readonly } from 'vue';
import { getRoleById, getUserTypes } from '@/service/admin-service';
import { getPasswordValidateRules } from '@/service/admin-service';

const MODE = readonly({
    VIEW: 0,
    CREATE: 1,
    UPDATE: 2,
});

const USER_STATUS = readonly({
    ACTIVE: 'A',
    DELETED: 'D',
    BLOCKED: 'L',
    EXPIRED: 'E',
});

const CARD_TABS = readonly({
    INFORMATION: 0,
    BLOCKAGES: 1,
    ROLES: 2,
    RESTRICTION: 3
});

const UI_ELEMENTS_IDS = readonly({
    USERS_GRID: 721,
    CARD: 722,
    PERSONAL_INFORMATION: 723,
    BLOCKAGES: 724,
    ROLES: 725,
    RESTRICTION: 726,
});

const state = reactive({
    userRequestBody: {
        id: null,
        user_login: '',
        user_type_id: 1,
        status: null,
        official_id: null,
        e_mail: '',
        expired_at: null,
        namedolzh: '',
        fio: '',
        department: '',
        mobile_phone: '',
        phone: '',
        from_ad: false,
        request_number: '',
        request_date: '',
        notification_push: false,
        notification_time: null,
        notification_email: false,
        notification_days: null,
        locked_since: null,
        locked_until: null,
        locks: [],
        deleted_locks: [],
        roles: [],
        department_rights: [],
        lock_reason: null,
        password_rules: {
            base: [],
            optional: [],
        },
    },
    areas: [],
    mutationAreas: [],
    areaGridInstance: null,
    userCardViewPopupVisible: false,
    officialPopupVisible: false,
    userCardPopupVisible: false,
    usersRolePopupVisible: false,
    massLocksPopupVisible: false,
    userLocksPopupVisible: false,
    userChangePasswordPopupVisible: false,
    generatedPasswordPopupVisible: false,
    userTypes: [],
    subdivisionPopupVisible: false,
    areaPopupVisible: false,
    roleAreasPopupVisible: false,
    isOpenedByUsersRole: false,
    isOpenUserCard: false,
    isOpenInsertAreas: false,
    selectedGroupId: null,
    currentGroup: null,
    isSubdivisionDataLoaded: null,
    currentTabIndex: 0,
    lockPopupVisible: false,
    isClosingConfirmed: true,
    dataHasNotChanged: true,
    requestBodyHasNotChanged: true,
    userBlockagesHasNotChanged: true,
    editingChanges: [],
    stopWatching: null,
    lockUserIds: [],
    lockReasons: [],
    lockFormData: {
        from: null,
        to: null,
        lock_reason: '',
    },
    lockTypes: [],
    formRef: '',
    mode: MODE.CREATE,
    lockLogins: [],
    roleId: null,
    roleName: null,
    roleCode: null,
    appId: null,
});

const clearLockFormData = () => {
    state.lockFormData = {
        from: null,
        to: null,
        lock_reason: '',
    };
};

const setLockFormData = () => {
    state.lockFormData = {
        from: state.userRequestBody.locked_since,
        to: state.userRequestBody.locked_until,
        lock_reason: state.userRequestBody.lock_reason,
    };
};

const addAreas = newArea => {
    state.areas = [...newArea, ...state.areas];
};

const addMutationAreas = newArea => {
    state.mutationAreas = [...newArea, ...state.mutationAreas];
};

const loadById = async (roleId, appId) => {
    state.appId = appId;
    const result = await getRoleById({ roleId, appId });
    if (result) {
        const { id, name, code, areas } = result;
        areas.forEach(area => (area.displayId = `${area.id}:a`));
        state.roleId = id;
        state.roleName = name;
        state.roleCode = code;
        state.areas = areas;

        if (!state.areas) state.areas = [];
    }
};

const getUserTypesList = async () => {
    const userTypes = await getUserTypes();
    if (userTypes) {
        state.userTypes = userTypes.items.map(type => ({
            id: type.id,
            name: type.name,
        }));
    }
};

const getPasswordValidateRulesList = async () => {
    const passwordRules = await getPasswordValidateRules(state.userRequestBody.user_type_id);
    if (passwordRules && passwordRules.success) {
        state.userRequestBody.password_rules = passwordRules.data;
    }
};

const setUserRequestBody = user => {
    state.userRequestBody = {
        id: user.id,
        official_id: user.official_id,
        user_login: user.user_login,
        user_type_id: user.user_type_id,
        deleted_locks: [],
        status: user.status,
        e_mail: user.e_mail,
        expired_at: user.expired_at,
        fio: user.fio,
        from_ad: user.from_ad,
        department: user.department,
        namedolzh: user.namedolzh,
        phone: user.phone,
        mobile_phone: user.mobile_phone,
        request_number: user.request_number,
        request_date: user.request_date,
        notification_days: user.notification_days?.toString(),
        locked_since: user.locked_since,
        locked_until: user.locked_until,
        locks: user.locks,
        notification_push: user.notification_push,
        notification_email: user.notification_email,
        notification_time: user.notification_time,
        roles: user.roles,
        data_rights: user.data_rights || [],
        lock_reason: user.lock_reason,
    };
};

const clearUserRequestBody = () => {
    state.userRequestBody = {
        id: null,
        user_login: '',
        user_type_id: 1,
        official_id: null,
        e_mail: '',
        deleted_locks: [],
        expired_at: null,
        namedolzh: '',
        fio: '',
        department: '',
        mobile_phone: '',
        phone: '',
        from_ad: false,
        password_expiration: null,
        request_number: '',
        request_date: '',
        notification_push: false,
        notification_time: null,
        notification_email: false,
        notification_days: null,
        locked_since: null,
        locked_until: null,
        locks: [],
        roles: [],
        department_rights: [],
        lock_reason: null,
    };
};

export default {
    MODE,
    USER_STATUS,
    CARD_TABS,
    UI_ELEMENTS_IDS,
    state,
    setUserRequestBody,
    loadById,
    addAreas,
    clearUserRequestBody,
    clearLockFormData,
    setLockFormData,
    addMutationAreas,
    getUserTypesList,
    getPasswordValidateRulesList,
};
